import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '../firebase';

function getElementLabel(element) {
  const text = element.textContent?.replace(/\s+/g, ' ').trim();
  const ariaLabel = element.getAttribute('aria-label');

  return ariaLabel || text || element.getAttribute('href') || element.type || 'unknown';
}

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackEvent('page_view', {
      page_location: window.location.href,
      page_path: `${location.pathname}${location.search}${location.hash}`,
      page_title: document.title,
    });
  }, [location]);

  useEffect(() => {
    const handleClick = (event) => {
      const element = event.target.closest('button, a');

      if (!element) {
        return;
      }

      const isButton = element.tagName.toLowerCase() === 'button';

      trackEvent(isButton ? 'button_click' : 'link_click', {
        element_label: getElementLabel(element),
        element_href: element.getAttribute('href') || '',
        page_path: window.location.pathname,
      });
    };

    const handleSubmit = (event) => {
      trackEvent('form_submit', {
        form_name: event.target.getAttribute('name') || event.target.className || 'contact-form',
        page_path: window.location.pathname,
      });
    };

    document.addEventListener('click', handleClick);
    document.addEventListener('submit', handleSubmit);

    return () => {
      document.removeEventListener('click', handleClick);
      document.removeEventListener('submit', handleSubmit);
    };
  }, []);

  return null;
}

export default AnalyticsTracker;
